import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import * as Yup from "yup";

import { useToasts } from "react-toast-notifications";
import { CreateAndDetailLayout } from "../../../components/CreateAndDetailLayout";
import { ButtonSubmit } from "../../../components/Form/ButtonSubmit";
import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { LayoutForm } from "../../../components/Form/LayoutForm";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import { Benefit, useBenefit } from "../../../hook/queries/useBenefits";
import api from "../../../service/api";
import { queryClient } from "../../../service/queryClient";
import { setFormikValues } from "../../../utils/setFormikValues";

export interface MatchParams {
  id?: string;
}

type CreateProps = Omit<Benefit, "id">;

const CreateAndDetail: React.FC = () => {
  const { addToast } = useToasts();
  const history = useHistory();
  const match = useRouteMatch<MatchParams>();
  const isUpdating = match?.params?.id ? true : false;
  const getBenefit = useBenefit(Number(match.params.id));

  const formik = useFormik({
    initialValues: {
      id: "",
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("É obrigatório"),
    }),
    onSubmit: (a) => {
      //@ts-ignore
      !isUpdating ? handleCreate(a) : handleUpdate(a);
    },
  });

  useEffect(() => {
    if (getBenefit?.isSuccess && getBenefit?.data && isUpdating)
      setFormikValues(getBenefit?.data, formik);
    // eslint-disable-next-line
  }, [getBenefit?.data, isUpdating, getBenefit?.isSuccess]);

  async function handleCreate(data: CreateProps) {
    try {
      await api.post("/benefits", data);

      queryClient.invalidateQueries("benefits");

      addToast("Beneficio criado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push("/beneficios");
    } catch (err) {
      return addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }
  async function handleUpdate(data: Benefit) {
    try {
      await api.put(`/benefits/${data.id}`, data);

      queryClient.invalidateQueries(["benefit", data.id]);
      queryClient.invalidateQueries("benefits");

      addToast("Beneficio alterado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push("/beneficios");
    } catch (err) {
      return addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }

  return (
    <CreateAndDetailLayout isLoading={getBenefit?.isLoading}>
      <PanelAndDetailAndCreateHeader
        title={isUpdating ? "Beneficio" : "Criar Beneficio"}
        goBack
      />

      <LayoutForm onSubmit={formik.handleSubmit}>
        {isUpdating && (
          <Input
            label="Código"
            {...formik.getFieldProps("id")}
            type="number"
            disabled
          />
        )}

        <GroupInput>
          <Input
            label="Nome"
            {...formik.getFieldProps("name")}
            error={
              formik.touched.name && formik.errors.name
                ? formik.errors.name
                : undefined
            }
          />
        </GroupInput>

        <ButtonSubmit>{isUpdating ? "Editar" : "Criar"}</ButtonSubmit>
      </LayoutForm>
    </CreateAndDetailLayout>
  );
};

export default CreateAndDetail;
